import { IColumn } from '../types'

export const cloneData = (arr: IColumn[]) => {
  try {
    return structuredClone(arr)
  } catch (err) {
    const newArr = []
    for (const item of arr) {
      if (typeof item === 'object') {
        newArr.push({ ...item })
      } else {
        newArr.push(item)
      }
    }
    return newArr
  }
}
